import { ReactComponent as ImageIcon } from '../../../assets/img/post-box/icon-image.svg';
import { ReactComponent as MailIcon } from '../../../assets/img/post-box/icon-mail.svg';
import { ReactComponent as PdfIcon } from '../../../assets/img/post-box/icon-pdf.svg';
import { ReactComponent as WordIcon } from '../../../assets/img/post-box/icon-word.svg';
import { ReactComponent as UploadIcon } from '../../../assets/img/post-box/icon-upload.svg';
import { ReactComponent as ChatIcon } from '../../../assets/img/post-box/icons-chat.svg';
import { ReactComponent as DismissIcon } from '../../../assets/img/icons/icon-dismiss.svg';
import { ReactComponent as AddIcon } from '../../../assets/img/icons/icon-add.svg';
import { ReactComponent as QuestionIcon } from '../../../assets/img/icons/icons-alert-question.svg';
import { ReactComponent as Alert } from '../../../assets/img/icons/icons-alert-error.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/img/icons/icons-content-download.svg';
import { ReactComponent as ChevronLeft } from '../../../assets/img/icons/icons-navigation-chevron-left.svg';
import { ReactComponent as CopyPaste } from '../../../assets/img/icons/icon-copy-paste.svg';
import { ReactComponent as ExpandMore } from '../../../assets/img/icons/icons-content-expand-more.svg';
import { ReactComponent as Confirm } from '../../../assets/img/icons/icons-content-confirm.svg';
import { ReactComponent as NavHome } from '../../../assets/img/menu/icon_home.svg';
import { ReactComponent as NavPostBox } from '../../../assets/img/menu/icon_postbox.svg';
import { ReactComponent as ContactChat } from '../../../assets/img/contacts/icons-content-chat.svg';
import { ReactComponent as ContactMail } from '../../../assets/img/contacts/icons-content-mail.svg';
import { ReactComponent as ContactTel } from '../../../assets/img/contacts/icons-content-tel.svg';
import { ReactComponent as ContactTwitter } from '../../../assets/img/contacts/icons-content-twitter.svg';
import { ReactComponent as ContactWhatsapp } from '../../../assets/img/contacts/icons-content-whatsapp.svg';
import { ReactComponent as Profile } from '../../../assets/img/icons/icons-content-profile.svg';
import { ReactComponent as Key } from '../../../assets/img/icons/icons-content-key.svg';
import { ReactComponent as Star } from '../../../assets/img/icons/icons-content-star.svg';
import { ReactComponent as StarFilled } from '../../../assets/img/icons/icons-content-star-filled.svg';
import { ReactComponent as StarFocus } from '../../../assets/img/icons/icons-content-star-focus.svg';
import { ReactComponent as StarFocusFilled } from '../../../assets/img/icons/icons-content-star-focus-filled.svg';
import { ReactComponent as WhatsappIcon } from '../../../assets/img/post-box/icons-content-whatsapp.svg';
import { ReactComponent as LetterIcon } from '../../../assets/img/icons/icons-content-letter.svg';
import { ReactComponent as LanguageIcon } from '../../../assets/img/icons/icons-content-language.svg';
import { ReactComponent as InfoIcon } from '../../../assets/img/icons/icons-content-information.svg';

const ICONS = {
  imageIcon: ImageIcon,
  mailIcon: MailIcon,
  pdfIcon: PdfIcon,
  wordIcon: WordIcon,
  uploadIcon: UploadIcon,
  chatIcon: ChatIcon,
  dismissIcon: DismissIcon,
  addIcon: AddIcon,
  questionIcon: QuestionIcon,
  alert: Alert,
  downloadIcon: DownloadIcon,
  chevronLeft: ChevronLeft,
  copyPaste: CopyPaste,
  expandMore: ExpandMore,
  confirm: Confirm,
  navHome: NavHome,
  navPostBox: NavPostBox,
  contactChat: ContactChat,
  contactMail: ContactMail,
  contactTel: ContactTel,
  contactTwitter: ContactTwitter,
  contactWhatsapp: ContactWhatsapp,
  profile: Profile,
  key: Key,
  star: Star,
  starFilled: StarFilled,
  starFocus: StarFocus,
  starFocusFilled: StarFocusFilled,
  whatsappIcon: WhatsappIcon,
  letterIcon: LetterIcon,
  languageIcon: LanguageIcon,
  infoIcon: InfoIcon
};

export default ICONS;
